"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LayerMouseEvent = /*#__PURE__*/function () {
  // original item that this event is related to
  // internal nebula info about the object
  // the mouse [lng,lat] raycasted onto the ground
  // browser event
  // reference to nebula
  function LayerMouseEvent(nativeEvent, _ref) {
    var data = _ref.data,
        groundPoint = _ref.groundPoint,
        nebula = _ref.nebula,
        metadata = _ref.metadata;

    _classCallCheck(this, LayerMouseEvent);

    _defineProperty(this, "canceled", void 0);

    _defineProperty(this, "data", void 0);

    _defineProperty(this, "metadata", void 0);

    _defineProperty(this, "groundPoint", void 0);

    _defineProperty(this, "nativeEvent", void 0);

    _defineProperty(this, "nebula", void 0);

    this.nativeEvent = nativeEvent;
    this.data = data;
    this.groundPoint = groundPoint;
    this.nebula = nebula;
    this.metadata = metadata;
  }

  _createClass(LayerMouseEvent, [{
    key: "stopPropagation",
    value: function stopPropagation() {
      this.nativeEvent.stopPropagation();
      this.canceled = true;
    }
  }]);

  return LayerMouseEvent;
}();

exports["default"] = LayerMouseEvent;